import { createSlice, createSelector } from "@reduxjs/toolkit";
import { selectAllDomainSkillPaths } from "./skillPathReducer";

const skillPathLevelsSlice = createSlice({
  name: "skillPathLevels",
  initialState: [],
  reducers: {
    addSkillPathLevels(state, action) {
      state.push(...action.payload);
    },
  },
});

export const skillPathLevelsActions = skillPathLevelsSlice.actions;

export const getSkillPathLevels = () => {
  return async (dispatch, getState) => {
    const skillPathLevels = getState().skillPathLevels;
    if (skillPathLevels.length !== 0) return;
    const { session } = getState();
    dispatch(
      skillPathLevelsActions.addSkillPathLevels(
        session?.tenantSettings?.skillProficiencyLevels.map((x) => ({
          id: x.level,
          name: x.name,
          rank: x.level,
        }))
      )
    );
  };
};

const selectAllSkillPathLevels = (state) => state.skillPathLevels;

export const selectDomainSkillPathLevels = createSelector(
  [selectAllSkillPathLevels, selectAllDomainSkillPaths],
  (skillPathLevels, academySkillPaths) => {
    return skillPathLevels
      .filter((spl) =>
        academySkillPaths.some((sp) => sp.skillPathLevelId === spl.id)
      )
      .sort((a, b) => a.rank - b.rank)
      .map((x) => ({ id: x.id, label: x.name }));
  }
);

// TODO: Update this selector when data model is ready
export const selectJobSkillPathLevels = createSelector(
  [selectAllSkillPathLevels],
  (skillPathLevels) => {
    return [...skillPathLevels]
      .sort((a, b) => a.rank - b.rank)
      .map((x) => ({ id: x.id, label: x.name }));
  }
);

export default skillPathLevelsSlice.reducer;
